export const COOKIE_ACCESS_TOKEN_NAME = 'AVIO-Token';
export const COOKIE_REFRESH_TOKEN_NAME = 'AVIO-RefreshToken';
export const DEEPLINK_URL = 'aviobookconnect://';
export const DEFAULT_PAGE_SIZE = 25;
export const MAGIC_LOGIN_PATH = 'idp/magic-login-verification';
export const MAX_ALLOWED_MESSAGE_CHARS = 12000;
export const DEVICE_ID_STORAGE_KEY = 'Avio-Device-Id';
export const TYPEAHEAD_DEBOUNCE_TIME = 300;
